import React from 'react';
import { AlertMessage, ButtonLink } from '@brighterionai/br-ui';
import { useHistory } from 'react-router-dom';
import { useAppStore } from 'Store';
import styles from './Alert.css';

export type AlertProps = {
    type: 'danger' | 'success' | 'warning' | 'help' | 'info';
    message: string;
    hideAlertHandle: () => void;
    isOpen: boolean;
    duration?: number;
    linkText?: string;
    linkTo?: string;
    linkType?: 'button' | 'link';
};
const Alert = ({ type, message, hideAlertHandle, isOpen, duration, linkText, linkTo, linkType }: AlertProps) => {
    const history = useHistory();
    const toggleSidePanel = useAppStore.use.toggleSidePanel?.();
    let updatedDuration = duration;

    if (!duration && type === 'success') {
        updatedDuration = 3000;
    }

    const handleLinkClick = () => {
        if (linkType === 'link' && linkTo) {
            history.push(linkTo);
        } else {
            toggleSidePanel();
        }
    };
    return (
        <AlertMessage
            className={styles.alertMainContainer}
            type={type}
            closeAlert={() => hideAlertHandle()}
            isOpen={isOpen}
            duration={updatedDuration}
            dataTestId='alert-message-modal'
        >
            <>
                <span className={styles.messageContent}>{message}</span>
                {linkText && linkType && (
                    <ButtonLink
                        dataTestId='alert-link'
                        className={styles.btnLink}
                        clickCb={handleLinkClick}
                        name={linkText}
                        size='small'
                        url='#'
                    />
                )}
            </>
        </AlertMessage>
    );
};
export default Alert;
